import script from "./ButtonHideSidbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonHideSidbar.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonHideSidbar.vue?vue&type=style&index=0&id=6b67e3da&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b67e3da"]])

export default __exports__